var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "ui-content__item-page ui-typography ui-item-page" },
      [
        _c("h2", { staticClass: "ui-item-page__title" }, [_vm._v("UI")]),
        _c("div", { staticClass: "ui-block" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-12" }, [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Title base-type"),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c("h1", [_vm._v("h1  Roboto-Medium 40px")]),
                    _c("h2", [_vm._v("h2  Roboto-Medium 26px")]),
                    _c("h3", [_vm._v("h3  Roboto-Bold 22px")]),
                    _c("h4", [_vm._v("h4  Roboto-Regular 20px")]),
                    _c("h5", [_vm._v("h5  Roboto-Medium 18px")]),
                    _c("h6", [_vm._v("h6  Roboto-Regular 18px")]),
                  ]),
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c("h1", [_vm._v("h1  Заголовок")]),
                    _c("h2", [_vm._v("h2  Заголовок")]),
                    _c("h3", [_vm._v("h3  Заголовок")]),
                    _c("h4", [_vm._v("h4  Заголовок")]),
                    _c("h5", [_vm._v("h5  Заголовок")]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "ui-block" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-4" }, [
                  _c("p", [
                    _vm._v(
                      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates deleniti temporibus quaerat perferendis at, impedit sequi sunt architecto laboriosam"
                    ),
                    _c("a", { attrs: { href: "#" } }, [
                      _vm._v("  link in text"),
                    ]),
                    _vm._v(
                      "    minima labore ratione possimus, omnis consequuntur distinctio facere, rerum quam quibusdam."
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "col-lg-4" }, [
                  _c("p", { staticClass: "italic" }, [
                    _vm._v(
                      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates deleniti temporibus quaerat perferendis at, impedit sequi sunt architecto laboriosam"
                    ),
                    _c("a", { attrs: { href: "#" } }, [
                      _vm._v("  link in text"),
                    ]),
                    _vm._v(
                      "    minima labore ratione possimus, omnis consequuntur distinctio facere, rerum quam quibusdam."
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "col-lg-4" }, [
                  _c("p", { staticClass: "bold" }, [
                    _vm._v(
                      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates deleniti temporibus quaerat perferendis at, impedit sequi sunt architecto laboriosam"
                    ),
                    _c("a", { attrs: { href: "#" } }, [
                      _vm._v("  link in text"),
                    ]),
                    _vm._v(
                      "    minima labore ratione possimus, omnis consequuntur distinctio facere, rerum quam quibusdam."
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "ui-block ui-ul-ol" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "col-lg-6" }, [
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }